import SVG15Year from '../svg/SVG15Year';
import SVGEmail from '../svg/SVGEmail';
import SVGPhoneSmall from '../svg/SVGPhoneSmall';
import SVGTalk from '../svg/SVGTalk';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function M() {
    const { useLang } = useGlobal();
    const { t } = useLang('PowerOcean.M');

    return (
        <div className={`power-ocean-home-M ${styles['power-ocean-home-M']}`}>
            <div className="sec13">
                <h2 className="title h5">{t('title')}</h2>
                <div className="img-box">
                    <SVG15Year />
                </div>
                <div className="text-box">
                    <h2 className="title pc">{t('title')}</h2>
                    <p className="desc">{t('desc')}</p>
                    <div className="icons">
                        <div className="icon-item">
                            <SVGEmail />
                        </div>
                        <div className="icon-item">
                            <SVGTalk />
                        </div>
                        <div className="icon-item">
                            <SVGPhoneSmall />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
